import React from 'react';
import { Icon, Link } from '@hover/blueprint';
import { Grid, GridItem } from '@chakra-ui/react';
import { iChevronRight } from '@hover/icons';
import styled from '@emotion/styled';

export interface IShowCasePartnersProps {
  partners: {
    logo: React.ReactNode;
    href: string;
    key: number;
  }[];
}

const PartnerWrapper = styled(GridItem)`
  img {
    object-fit: contain !important;
  }
`;

const ShowCasePartners: React.FC<IShowCasePartnersProps> = ({ partners }) => (
  <Grid
    templateColumns={[
      'repeat(1, 1fr)',
      'repeat(2, 1fr)',
      'repeat(3, 1fr)',
      `repeat(${4}, 1fr)`,
    ]}
    maxW="7xl"
    mx="auto"
    justifyContent="center"
    gap={10}
    pt="50px"
    pb="100px"
    px={4}
  >
    {partners.map(c => (
      <PartnerWrapper
        bgColor="linear-gradient(180deg, #F9FCFF 0%, #FCFDFF 100%)"
        boxShadow="0px 44px 66px 2px rgb(118 118 118 / 5%)"
        borderRadius={10}
        borderTop="2px solid #F9FCFF"
        transition="all .2s ease-in-out"
        maxH={116}
        _hover={{
          borderColor: '#247DDC',
          boxShadow: '0px 44px 66px 2px rgb(118 118 118 / 20%)',
          cursor: 'pointer',
        }}
        px={6}
        py={8}
        key={c.key}
        as={Link}
        href={c.href}
        d="flex"
        justifyContent="space-between"
      >
        {c.logo}
        <Icon icon={iChevronRight} size="large" />
      </PartnerWrapper>
    ))}
  </Grid>
);

export default ShowCasePartners;
